/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { KindEnum } from './kindEnum';
import { LevelEnum } from './levelEnum';
import { NullEnum } from './nullEnum';
import { RecordFile } from './recordFile';
import { TimeLineCompetenceDetail } from './timeLineCompetenceDetail';
import { TimeLineSkillDetail } from './timeLineSkillDetail';

export interface TimelineEntryRead { 
    readonly id: string;
    readonly created: Date;
    kind: KindEnum;
    readonly teacher: string;
    /**
     * Název aktivity, pokud je tento záznam spojen s aktivitou.
     */
    activityName?: string;
    skillNames?: any;
    readonly skillDetails: Array<TimeLineSkillDetail>;
    competencyNames?: any;
    readonly competenceDetails: Array<TimeLineCompetenceDetail>;
    literacyNames?: any;
    note?: string;
    level?: LevelEnum | NullEnum;
    readonly files: Array<RecordFile>;
    /**
     * Datum, kdy se událost stala.
     */
    date: Date;
    /**
     * Return the model name of the source object.
     */
    readonly sourceContentType: string;
    readonly sourceObjectId: string;
}